import { get } from 'lodash';

import { ASSET_TYPE, LIABILITY_TYPE, FIELD_PATHS } from '@funnels/constants';
import { Asset, Liability, AnyFormValues } from '@funnels/types';

type ValidEntities = 'assets' | 'liabilities';

export default function getEntitiesWithType(
  formValues: AnyFormValues,
  generalEntityType: ValidEntities,
  specificEntityType: ASSET_TYPE | LIABILITY_TYPE
) {
  switch (generalEntityType) {
    case 'assets':
      return get(formValues, FIELD_PATHS.ASSETS(), []).filter((a: Asset) => a.type === specificEntityType);
    case 'liabilities':
      return get(formValues, FIELD_PATHS.LIABILITIES(), []).filter((l: Liability) => l.type === specificEntityType);
    default:
      return [];
  }
}
